import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import useIsMounted from "~/common/useIsMounted";

const LoginModalWrapper = React.lazy(
  () => import("~/common/LoginModal/LoginModalWrapper"),
);

export default () => {
  const mounted = useIsMounted();

  return (
    <>
      {mounted &&
        ReactDOM.createPortal(
          <Suspense fallback={null}>
            <LoginModalWrapper />
          </Suspense>,

          document.querySelector("body") as Element,
        )}
    </>
  );
};
